import { PropsWithChildren, useRef } from 'react'
import { useGSAP } from '@gsap/react'
import { Slot } from '@radix-ui/react-slot'
import ScrollTrigger from 'gsap/dist/ScrollTrigger'

import { useLenis } from '@/contexts/lenis'
import { useLoader } from '@/store/loader'

import { Animation } from '@/types'

export type MotionProps = PropsWithChildren<{
  // eslint-disable-next-line no-unused-vars
  animation?: (props: Animation<HTMLElement>) => (() => void) | void // gsap.core.Timeline
  preventOnTouch?: boolean
  revertOnUpdate?: boolean
}>

const Motion = ({
  animation,
  preventOnTouch = true,
  revertOnUpdate = true,
  ...props
}: MotionProps) => {
  const scope = useRef<HTMLDivElement>(null!)
  const loaded = useLoader((state) => state.loaded)
  const { lenis } = useLenis()

  useGSAP(
    (context) => {
      const touch = ScrollTrigger.isTouch > 0
      const prevent = touch && preventOnTouch

      if (!loaded || !lenis || prevent) return

      const revert = animation?.({
        nodeRef: scope.current,
        reverse: false,
        context
      })

      return () => {
        revert?.()
      }
    },
    { dependencies: [loaded, lenis], scope, revertOnUpdate }
  )

  return <Slot ref={scope} {...props} />
}

export default Motion
